import initVueApp from "@/core.js";
const component = require(`./../views/Sms.vue`).default;
initVueApp(component);
